/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@/shared/api/axiosInstance";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  DeleteApiV1LocationCitiesIdMutationResponse,
  DeleteApiV1LocationCitiesIdPathParams,
  DeleteApiV1LocationCitiesId401,
  DeleteApiV1LocationCitiesId404,
  DeleteApiV1LocationCitiesId500,
} from "../../types/locationCityController/DeleteApiV1LocationCitiesId.ts";

function getDeleteApiV1LocationCitiesIdUrl(
  id: DeleteApiV1LocationCitiesIdPathParams["id"],
) {
  const res = {
    method: "DELETE",
    url: `/api/v1/location/cities/${id}` as const,
  };
  return res;
}

/**
 * @description Exclui permanentemente uma cidade. **(Requer Authorization para autenticação)**
 * @summary Excluir cidade (Requer Authorization para autenticação)
 * {@link /api/v1/location/cities/:id}
 */
export async function deleteApiV1LocationCitiesId(
  id: DeleteApiV1LocationCitiesIdPathParams["id"],
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    DeleteApiV1LocationCitiesIdMutationResponse,
    ResponseErrorConfig<
      | DeleteApiV1LocationCitiesId401
      | DeleteApiV1LocationCitiesId404
      | DeleteApiV1LocationCitiesId500
    >,
    unknown
  >({
    method: "DELETE",
    url: getDeleteApiV1LocationCitiesIdUrl(id).url.toString(),
    ...requestConfig,
  });
  return res.data;
}
